import { useEffect, useState } from "react";

type AssetState = [boolean, () => void];

export const useAssetState = (src: string): AssetState => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return [loaded, (): void => setLoaded(true)];
};
